var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { defaultOptionList } from './defaults';
import { DivTag } from '../../Utils/AtomicTag';
import Loading from '../Loading';
import CacheMap from '../AutoComplete/setMap';
import { KeyCode } from '../../Utils/keyCode';
import Empty from '../Empty';
var OptionList = /** @class */ (function (_super) {
    __extends(OptionList, _super);
    function OptionList(props) {
        var _this = _super.call(this, props) || this;
        _this.listRef = React.createRef();
        /**
         * 选中当前提示列
         */
        _this.selectItemOption = function (e, item) {
            if (item) {
                _this.props.selectOption(e, item);
            }
        };
        _this.handerMouseDown = function (e) {
            if (_this.state.mouseOver) {
                e.preventDefault();
            }
        };
        _this.handleMouseEnter = function () {
            _this.setState({
                mouseOver: true,
            });
        };
        _this.handleMouseLeave = function () {
            _this.setState({
                mouseOver: false,
            });
        };
        /** 获取可以选中的项 */
        _this.getEnabledActiveIndex = function (index, offset) {
            if (offset === void 0) { offset = 1; }
            var len = _this.props.options.length;
            for (var i = 0; i < len; i += 1) {
                var current = (index + i * offset + len) % len;
                var options = _this.props.options[current].options;
                if (!options) {
                    return current;
                }
            }
            return -1;
        };
        /** 键盘操作 */
        _this.onKeyDown = function (e) {
            var activeIndex = _this.state.activeIndex;
            switch (e.which) {
                // >>> Arrow keys
                case KeyCode.UP:
                case KeyCode.DOWN: {
                    var offset = 0;
                    if (e.which === KeyCode.UP) {
                        offset = -1;
                    }
                    else if (e.which === KeyCode.DOWN) {
                        offset = 1;
                    }
                    var nextActiveIndex = _this.getEnabledActiveIndex(activeIndex + offset, offset);
                    _this.setState({
                        activeIndex: nextActiveIndex,
                    });
                    _this.scrollIntoView(nextActiveIndex);
                    e.preventDefault();
                    break;
                }
                // >>> Select
                case KeyCode.ENTER: {
                    var item = _this.props.options[activeIndex];
                    if (item) {
                        _this.props.selectOption(e, item);
                        e.preventDefault();
                    }
                    break;
                }
            }
        };
        _this.createCacheMap = function () {
            var _a;
            var cacheMap = new CacheMap();
            (_a = _this.listRef.current) === null || _a === void 0 ? void 0 : _a.childNodes.forEach(function (itemElement, key) {
                var offsetHeight = itemElement.offsetHeight;
                if (cacheMap.get(key) !== offsetHeight) {
                    cacheMap.set(key, offsetHeight);
                }
            });
            _this.setState({
                cacheMap: cacheMap,
            });
        };
        /**
         * options 列表滚动 区分目标item的顶部 itemTop 和底部 itemBottom
         */
        _this.scrollIntoView = function (nextIndex) {
            if (nextIndex === void 0) { nextIndex = 0; }
            var cacheMap = _this.state.cacheMap;
            _this.createCacheMap();
            if (_this.listRef.current && Object.keys(cacheMap).length > 0) {
                var height = _this.listRef.current.clientHeight;
                var stackTop = 0;
                var itemTop = 0;
                var itemBottom = 0;
                for (var i = 0; i <= nextIndex; i++) {
                    itemTop = stackTop;
                    itemBottom = itemTop + cacheMap.get(i);
                    stackTop = itemBottom;
                }
                var scrollTop = _this.listRef.current.scrollTop;
                var scrollBottom = scrollTop + height;
                if (itemTop < scrollTop) {
                    // scroll to top
                    _this.listRef.current.scrollTo(0, 0);
                }
                else if (itemBottom > scrollBottom) {
                    // scroll to bottom
                    _this.listRef.current.scrollTo(0, itemBottom - height);
                }
            }
        };
        // 获取目标元素的相对于视窗的位置
        _this.getElPosition = function (el) {
            return el && el.getBoundingClientRect();
        };
        /** 无列表情况 */
        _this.notFoundRender = function () {
            var defaultNotFoundContent = _this.props.notFoundContent ? (_this.props.notFoundContent) : (React.createElement(Empty, { image: Empty.PRESENTED_IMAGE_SIMPLE }));
            return React.createElement(DivTag, { atomics: ['flex', 'items-center'] }, defaultNotFoundContent);
        };
        /** loading 加载中 */
        _this.loadingRender = function () {
            var loadingCls = ['h-px-34', 'px-px-12', 'flex', 'items-center'];
            return (React.createElement(DivTag, { atomics: loadingCls },
                React.createElement(Loading, { size: "small" })));
        };
        _this.renderItem = function (item, index) {
            var activeIndex = _this.state.activeIndex;
            var popItemCls = [
                'w-full',
                'h-px-34',
                'px-px-15',
                'leading-10',
                'cursor-pointer',
            ];
            if (activeIndex == index) {
                popItemCls.push('bg-gray-100');
            }
            return (React.createElement(DivTag, { atomics: popItemCls, onClick: function (e) { return _this.selectItemOption(e, item); }, onMouseEnter: function () {
                    if (activeIndex == index) {
                        return;
                    }
                    _this.setState({
                        activeIndex: index,
                    });
                } }, item.children));
        };
        /** 设置 弹框样式 */
        _this.setStyle = function () {
            var _a = _this.props, container = _a.container, measureRef = _a.measureRef, placement = _a.placement, textareaRef = _a.textareaRef;
            var targetElPos = _this.getElPosition(container.current);
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            var scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
            var prixEl = measureRef.current.getElementsByTagName('span')[0];
            // 弹框方向
            var diff = 20;
            if (_this.listRef.current.clientHeight && placement.toLowerCase() == 'top') {
                diff = -_this.listRef.current.clientHeight;
            }
            var style = {
                boxShadow: '0px 2px 8px 0px rgba(0,0,0,0.15)',
                left: scrollLeft + targetElPos.left + prixEl.offsetLeft + 12,
                top: scrollTop + targetElPos.top + prixEl.offsetTop + diff - textareaRef.current.scrollTop,
            };
            _this.setState({
                style: style,
            });
        };
        _this.renderList = function () {
            var options = _this.props.options;
            return options.length > 0
                ? options.map(function (item, index) {
                    return _this.renderItem(item, index);
                })
                : _this.notFoundRender();
        };
        /** 渲染提及的列表 */
        _this.renderMentions = function () {
            var _a = _this.props, loading = _a.loading, options = _a.options;
            var popCls = [
                'absolute',
                'rounded',
                'bg-white',
                'max-h-px-256',
                'overflow-y-auto',
            ];
            if (options.length > 0 || loading) {
                popCls.push('min-w-px-150');
            }
            else {
                popCls.push('min-w-px-160', 'flex', 'justify-center');
            }
            return (React.createElement(DivTag, { atomics: popCls, style: _this.state.style, onMouseEnter: _this.handleMouseEnter, onMouseLeave: _this.handleMouseLeave, onMouseDown: function (e) { return _this.handerMouseDown(e); }, ref: _this.listRef, autoPrefixedClassName: "mentions-option-list-contain" }, !loading ? _this.renderList() : _this.loadingRender()));
        };
        _this.state = {
            activeIndex: 0,
            mouseOver: false,
            cacheMap: {},
            height: 20,
            style: {},
        };
        return _this;
    }
    OptionList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        var nextOpen = nextProps.open, nextOptions = nextProps.options;
        var _a = this.props, open = _a.open, options = _a.options;
        // keydown 事件绑定
        if (nextOpen !== open) {
            if (nextOpen) {
                document.addEventListener('keydown', this.onKeyDown, false);
            }
            else {
                document.removeEventListener('keydown', this.onKeyDown);
            }
        }
        if (nextOptions.length != options.length && nextOpen) {
            setTimeout(function () {
                _this.setStyle();
            }, 0);
        }
    };
    OptionList.prototype.componentDidMount = function () {
        var _this = this;
        setTimeout(function () {
            _this.setStyle();
        }, 0);
    };
    OptionList.prototype.componentWillUnmount = function () {
        document.removeEventListener('keydown', this.onKeyDown);
    };
    OptionList.prototype.render = function () {
        return this.props.open && ReactDOM.createPortal(this.renderMentions(), document.body);
    };
    OptionList.defaultProps = defaultOptionList;
    return OptionList;
}(React.PureComponent));
export { OptionList };
